export default {
    setRequestError(state, payload){
      state.request_error = payload.message;
    },
    setVendors(state, payload) {
      state.vendors = payload;
    },
    setShowrooms(state, payload) {
      state.showrooms = payload;
    },
    setConnections(state, payload) {
      state.connections = payload;
    }
  };